// src/Components/Forms/Financement/Salam/Validation/Tab4.tsx
import React from 'react';
import { Box, Grid } from '@mui/material';
import { Form, Select } from 'antd';
import InputForm from '../../../../InputT';
import SelectMultipleOptionPanier from '../../../../SelectMultipleOptionPanier';
import ParamsPicklist from '../../../../../Types/ParamsPicklist';


let searchOperat: ParamsPicklist = {
  CodeAgence: '',
  Table: "OPERAT",
  Colonne1: "CODOPE",
  Colonne2: "LIBELL",
  Colagence: '101',
  Choix: 22
};
interface Tab4Props {
  form?: any;
  fraisOptions: { value: string; label: string }[];
  fraisSelectionnes: string[];
  setFraisSelectionnes: (codes: string[]) => void;
  disabled?: boolean;
}

function Tab4(props: Tab4Props) {
  const handleChange = (values: string[]) => {
    if (props.disabled) return; // empêche la modification en validation
    props.setFraisSelectionnes(values);
    props.form.setFieldValue('CodeFrais', values);
  };

  return (
    <div className="tabItem">
          <Box fontStyle="inherit" className="border" width={"85%"} position={"absolute"}>
            <Grid container spacing={2}>
              <Grid item xs={12} md={12} lg={12}>
                        <SelectMultipleOptionPanier
                          notRequired
                          disabled
                          form={props.form}
                          Size="large"
                          width={4}
                          label="Frais de gestion"
                          name="CodeFrais"
                          Parametre={searchOperat}
                        />
                      </Grid>
            </Grid>
          </Box>
        </div>
  );
}

export default Tab4;